var _filter, _filter2, _filter3, _filter4, _filter5, _g, _path, _g2, _path2, _g3, _path3, _g4, _path4, _g5, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoAppsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 116,
    viewBox: "0 0 272 116",
    width: 272,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 93,
    width: 93,
    x: 179,
    y: 1
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    mode: "normal",
    result: "shape"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "b",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 93,
    width: 93,
    x: 89,
    y: 0
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    mode: "normal",
    result: "shape"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "c",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 93,
    width: 93,
    x: 0,
    y: 1
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    mode: "normal",
    result: "shape"
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "d",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 93,
    width: 93,
    x: 44,
    y: 23
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    mode: "normal",
    result: "shape"
  }))), _filter5 || (_filter5 = /*#__PURE__*/React.createElement("filter", {
    id: "e",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 93,
    width: 93,
    x: 136,
    y: 23
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    mode: "normal",
    result: "shape"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 225.5,
    cy: 45.5,
    fill: "#fff",
    r: 30.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m226 41.5 2.116 5.088 5.492.44-4.184 3.584 1.278 5.36-4.702-2.872-4.702 2.872 1.278-5.36-4.184-3.584 5.492-.44zm0 5.207-.739 1.777-1.916.153 1.46 1.251-.447 1.871 1.642-1.003 1.641 1.003-.446-1.87 1.459-1.252-1.915-.153zm-4-11.707v9h-2v-9zm10 0v9h-2v-9zm-5 0v5h-2v-5z",
    fill: "#4C5664"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 135.5,
    cy: 44.5,
    fill: "#fff",
    r: 30.5
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m145 51h2v2h-22v-2h2v-15c0-.2652.105-.5196.293-.7071.187-.1875.442-.2929.707-.2929h10c.265 0 .52.1054.707.2929.188.1875.293.4419.293.7071v15h4v-8h-2v-2h3c.265 0 .52.1054.707.2929.188.1875.293.4419.293.7071zm-16-14v14h8v-14zm2 6h4v2h-4zm0-4h4v2h-4z",
    fill: "#4C5664"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 45.5,
    fill: "#fff",
    r: 30.5
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m50.199 42.945c-.4337-.4109-.7127-.9586-.79-1.551l-.403-3.083-2.73 1.486c-.5249.286-1.1324.3825-1.72.273l-3.056-.57.57 3.056c.1094.5877.013 1.1951-.273 1.72l-1.486 2.73 3.083.403c.592.0776 1.1393.3565 1.55.79l2.138 2.257 1.336-2.807c.2564-.5394.6907-.9741 1.23-1.231l2.808-1.336zm.025 5.563-2.213 4.65c-.0419.088-.1045.1644-.1825.2227s-.1691.0967-.2652.112c-.0962.0152-.1947.0068-.2869-.0245s-.1754-.0845-.2424-.1552l-3.542-3.739c-.0947-.0998-.2207-.164-.357-.182l-5.107-.668c-.0965-.0127-.1885-.0487-.2679-.1048-.0795-.0562-.1441-.1309-.1883-.2176s-.0667-.1829-.0654-.2802.0262-.1928.0726-.2784l2.462-4.524c.0654-.121.0873-.2608.062-.396l-.943-5.063c-.0179-.0958-.0122-.1946.0166-.2877.0289-.0931.08-.1778.1489-.2467.0689-.069.1536-.1201.2468-.1489.0931-.0289.1918-.0346.2877-.0167l5.063.943c.1352.0254.275.0035.396-.062l4.524-2.462c.0856-.0464.1812-.0713.2786-.0725s.1936.0213.2803.0656c.0868.0443.1614.1091.2175.1887s.092.1717.1046.2682l.668 5.106c.0179.1364.0822.2624.182.357l3.739 3.542c.0706.0671.1239.1503.1552.2425s.0397.1906.0244.2868c-.0152.0962-.0537.1872-.112.2652s-.1347.1407-.2226.1825l-4.65 2.213c-.1245.0593-.2248.1595-.284.284zm.797 1.927 1.414-1.414 4.243 4.242-1.415 1.415z",
    fill: "#4C5664"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 67.5,
    fill: "#fff",
    r: 30.5
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m81 63.994c-.0005-.7878.1544-1.568.4558-2.2958.3014-.7279.7434-1.3891 1.3007-1.9459.5574-.5568 1.2191-.9981 1.9472-1.2988.7282-.3007 1.5085-.4548 2.2963-.4535h8c3.313 0 6 2.695 6 5.994v12.006h-14c-3.313 0-6-2.695-6-5.994zm18 10.006v-10.006c-.0026-1.0595-.4251-2.0748-1.1749-2.8234-.7497-.7486-1.7656-1.1695-2.8251-1.1706h-8c-.5252-.0013-1.0454.1011-1.5309.3012-.4855.2002-.9267.4943-1.2983.8653-.3717.3711-.6664.8119-.8673 1.2971s-.304 1.0053-.3035 1.5304v6.012c.0026 1.0595.4251 2.0748 1.1749 2.8234.7497.7486 1.7656 1.1696 2.8251 1.1706zm-6-8h2v2h-2zm-6 0h2v2h-2z",
    fill: "#4C5664"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 182.5,
    cy: 67.5,
    fill: "#fff",
    r: 30.5
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m188 76h-10c-1.417.0009-2.788-.4996-3.871-1.4128s-1.809-2.1803-2.047-3.5769c-.239-1.3965.025-2.8324.743-4.0534.719-1.221 1.846-2.1484 3.183-2.6179-.045-.9463.102-1.892.433-2.7797.331-.8878.839-1.6991 1.492-2.3849.654-.6857 1.44-1.2316 2.311-1.6046s1.809-.5653 2.756-.5653 1.885.1923 2.756.5653 1.657.9189 2.311 1.6046c.653.6858 1.161 1.4971 1.492 2.3849.331.8877.478 1.8334.433 2.7797 1.337.4695 2.464 1.3969 3.183 2.6179.718 1.221.982 2.6569.743 4.0534-.238 1.3966-.964 2.6637-2.047 3.5769s-2.454 1.4137-3.871 1.4128zm0-12c0-.667-.133-1.3273-.392-1.942s-.638-1.1715-1.115-1.6374c-.477-.466-1.043-.8318-1.664-1.0758-.62-.244-1.284-.3614-1.951-.3452-.666.0162-1.323.1657-1.931.4396s-1.156.6667-1.61 1.1553c-.454.4887-.805 1.0632-1.034 1.6897-.229.6266-.33 1.2926-.297 1.9588l.07 1.488-1.404.494c-.889.3146-1.639.9333-2.117 1.7469-.478.8137-.652 1.7699-.494 2.6999.159.93.642 1.774 1.362 2.383.721.609 1.634.9437 2.577.9452h10c.736-.0002 1.458-.2037 2.086-.588.629-.3843 1.138-.9346 1.474-1.5901.335-.6555.483-1.3909.427-2.1251-.056-.7343-.313-1.4388-.744-2.0361-.43-.5973-1.017-1.0641-1.696-1.3491-.679-.2849-1.424-.3769-2.152-.2658s-1.411.421-1.974.8955-.984 1.0952-1.217 1.7937l-1.898-.633c.399-1.1946 1.163-2.2335 2.185-2.9697 1.022-.7361 2.25-1.1323 3.509-1.1323z",
    fill: "#4C5664"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAppsIcon);
export default __webpack_public_path__ + "static/media/no-apps-icon.f33d42c91b48c9ad6bc53e5989f53bb7.svg";
export { ForwardRef as ReactComponent };